export default "__VITE_ASSET__4ERPFJcB__"